import React from "react";
import { ErrorMessage } from "@hookform/error-message";

type InputProps = {
  name: string;
  type: string;
  change?: (tabName: string, state: any) => void;
  changeFile?: (e: any, tabName: any) => void;
  theme: any;
  placeholder?: string;
  value?: string;
  register: any;
  required: boolean;
  errors: any;
  title?: string;
  tabName?: string;
  state?: any;
};

const Input = ({
  name,
  type,
  placeholder,
  theme,
  errors,
  register,
  required,
  title,
  changeFile,
  tabName,
  state
}: InputProps) => {
  const InputStyles = {
    input: {
      border: 0,
      borderRadius: 0,
      boxShadow: "none",
      margin: "0 auto",
      outline: "none",
      padding: `${theme?.to_rem("16px")} 0`,
      transition: "0.3s",
      width: "100%",
      borderBottom: `1px solid ${theme?.colors?.border_color}`,
      marginTop: "10px",
    },
  };

  return (
    <div style={{ marginBottom: "20px" }}>
      <input
        type={type === "email" ? "text" : type}
        {...register(name, {
          required: required ? `${placeholder} is required` : false,
          pattern:
            type === "email"
              ? {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Please enter a valid email address",
                }
              : title === "Url"
              ? {
                  value: /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/i,
                  message: "Please enter a valid url",
                }
              : {},
                onChange: (e:any) => {
            if (name == "documentNumber") {
              changeFile && changeFile(e, tabName);
            }
                }
        })}
        style={{ ...InputStyles.input }}
        placeholder={placeholder}
      />
      <ErrorMessage
        errors={errors}
        name={name}
        as="span"
        className="error-form"
      />
    </div>
  );
};

export default Input;
